<div class="form-group position-relative row mt-3">
  <div class="col">
    @if (props.label) {
      <h2
        class="col d-block"
        >
        {{ props.label }}
      </h2>
    }
    @if (props.template) {
      <div
        [class]="props.className"
        [innerHtml]="props.template"
      ></div>
    }
  </div>

  @if (props.tooltip) {
    <div
      class="template-tooltip col-1 mt-3"
      >
      <i
        class="col-1 far fa-question-circle my-auto"
        (click)="openTooltip()"
      ></i>
    </div>
  }
</div>
